import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Form, Button, Table, Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { fetchEv_list, addEv, removeEv } from '../../store';
import axios from 'axios';
import config from '../../config';
import './EnvironmentSetting.css';

function EnvironmentSetting() {
  const dispatch = useDispatch();
  const Ev_list = useSelector((state) => state.Ev_list || {});
  const evData = useSelector((state) => state.evData || {});

  const settingList = useSelector((state) => state.settingList || {});
  
  const [inputcommPort, setcommPort] = useState('RS485-CH1');
  const [inputAddress, setInputAddress] = useState('1');
  const [inputName, setInputName] = useState('엠알티표준-1');
  const [inputProtocol, setInputProtocol] = useState('엠알티-Modbus');
  const [inputEthernetIp, setInputEthernetIp] = useState('192.168.0.101');
  const [inputEthernetPort, setInputEthernetPort] = useState('8080');
  const [showModal, setShowModal] = useState(false);
  const [editIndex, setEditIndex] = useState(null);

  const [temperatureTypes, setTemperatureTypes] = useState([]);
  const [sunTypes, setSunTypes] = useState([]);

  const { commPortList = [], sensor_protocolList = [] } = settingList;

  useEffect(() => {
    dispatch(fetchEv_list());
  }, [dispatch]);

  useEffect(() => {
    if (Ev_list.seq) {
      setTemperatureTypes(Ev_list.seq.map((_, index) => Ev_list.ev_temperatureType[index]));
      setSunTypes(Ev_list.seq.map((_, index) => Ev_list.ev_sunType[index]));
    }
  }, [Ev_list]);

  // 온도 타입 선택 시 해당 장비만 DB 저장
  const handleTemperatureChange = async (index, value) => {
    const updatedTemperatureTypes = [...temperatureTypes];
    updatedTemperatureTypes[index] = value;
    setTemperatureTypes(updatedTemperatureTypes);

    await updateEvTemperatureAndSunTypes(index, value, sunTypes[index]);
    alert('저장되었습니다.');
  };

  // 일사량 타입 선택 시 해당 장비만 DB 저장
  const handleSunTypeChange = async (index, value) => {
    const updatedSunTypes = [...sunTypes];
    updatedSunTypes[index] = value;
    setSunTypes(updatedSunTypes);

    await updateEvTemperatureAndSunTypes(index, temperatureTypes[index], value);
    alert('저장되었습니다.');
  };


  // DB 업데이트 함수 (온도 타입과 일사량 타입)
  const updateEvTemperatureAndSunTypes = async (index, temperatureType, sunType) => {
    const updatedEv = {
      commPort: Ev_list.ev_commPort[index],
      address: Ev_list.ev_address[index],
      name: Ev_list.ev_name[index],
      protocol: Ev_list.ev_protocol[index],
      ethernetIp: Ev_list.ev_ethernetIp[index],
      ethernetPort: Ev_list.ev_ethernetPort[index],
      ev_temperatureType: temperatureType,
      ev_sunType: sunType,
    };

    try {
      const response = await axios.put(`${config.backendUrl}/api/update_ev/${Ev_list.seq[index]}`, updatedEv);
      if (response.status === 200) {
        // console.log(`장비 ${index + 1} 업데이트 완료`);
      } else {
        console.error(`장비 ${index + 1} 업데이트 실패:`, response);
      }
    } catch (error) {
      console.error(`장비 ${index + 1} 업데이트 중 오류 발생:`, error);
    }
  };

  // 센서 추가 — 입력 폼의 ID/이름 사용, 대수 제한·타입 강제 없음
  const evAddClick = async () => {
    if (!inputAddress?.toString().trim()) {
      alert('장비 ID를 입력하세요.');
      return;
    }

    const newEv = {
      commPort: inputcommPort,
      address: inputAddress.toString(),
      name: inputName,
      protocol: inputProtocol,
      ethernetIp: inputcommPort === 'ETHERNET' ? inputEthernetIp : null,
      ethernetPort:
        inputcommPort === 'ETHERNET'
          ? inputEthernetPort !== ''
            ? parseInt(inputEthernetPort, 10)
            : null
          : null,
      ev_temperatureType: 0,
      ev_sunType: 0,
    };

    try {
      const response = await axios.post(`${config.backendUrl}/api/evs`, newEv);
      if (response.status === 201) {
        alert('환경 센서 추가 완료');
        dispatch(fetchEv_list());

        const currentAddr = parseInt(inputAddress, 10);
        if (!Number.isNaN(currentAddr)) {
          const nextAddr = currentAddr + 1;
          setInputAddress(String(nextAddr));
          setInputName(`엠알티표준-${nextAddr}`);
        }
      } else {
        console.error('환경 센서 추가 실패:', response);
      }
    } catch (error) {
      console.error('환경 센서 추가 중 오류 발생:', error);
      alert(error.response?.data?.message || '환경 센서 추가 중 오류가 발생했습니다.');
    }
  };
  

  // 수정 버튼 클릭 시 모달에 기존 값을 로드하여 편집
  const handleEditClick = (index) => {
    setEditIndex(index);
    setcommPort(Ev_list.ev_commPort[index]);
    setInputAddress(Ev_list.ev_address[index]);
    setInputName(Ev_list.ev_name[index]);
    setInputProtocol(Ev_list.ev_protocol[index]);
    setInputEthernetIp(Ev_list.ev_ethernetIp[index]);
    setInputEthernetPort(Ev_list.ev_ethernetPort[index]);
    setShowModal(true);
  };

  // 수정 사항 저장 함수 정의
  const handleSaveClick = async () => {
    const updatedEv = {
      commPort: inputcommPort,
      address: inputAddress,
      name: inputName,
      protocol: inputProtocol,
      ethernetIp: inputcommPort === 'ETHERNET' ? inputEthernetIp : null,
      ethernetPort: inputcommPort === 'ETHERNET' ? (inputEthernetPort !== '' ? parseInt(inputEthernetPort) : null) : null,
      ev_temperatureType: Ev_list.ev_temperatureType[editIndex],  // 리덕스 스토어에서 값 가져오기
      ev_sunType: Ev_list.ev_sunType[editIndex],  // 리덕스 스토어에서 값 가져오기
    };

    try {
      const response = await axios.put(`${config.backendUrl}/api/update_ev/${Ev_list.seq[editIndex]}`, updatedEv);
      if (response.status === 200) {
        // console.log(`장비 ${editIndex + 1} 업데이트 완료`);
        dispatch(fetchEv_list());
        setShowModal(false);  // 저장 후 모달 닫기
        alert('저장되었습니다.');  // 저장 완료 후 알림 팝업 띄우기
      } else {
        console.error(`장비 ${editIndex + 1} 업데이트 실패:`, response);
      }
    } catch (error) {
      console.error(`장비 ${editIndex + 1} 업데이트 중 오류 발생:`, error);
    }
  };

  const handleDeleteClick = (index) => {
    const confirmDelete = window.confirm('정말로 삭제하시겠습니까?');
    if (confirmDelete) {
      const seq = Ev_list.seq[index];
      axios.delete(`${config.backendUrl}/api/evs/${seq}`)
        .then(() => {
          dispatch(removeEv(index));
          alert(`${Ev_list.ev_name[index]} 삭제 완료`);
        })
        .catch(error => console.error('삭제 중 오류 발생:', error));
    }
  };

  return (
    <Container className="mt-5">
      <Row className="justify-content-center align-items-center">
        <Col md="2">
          <Form.Label>통신 포트</Form.Label>
          <Form.Control as="select" value={inputcommPort} onChange={(e) => setcommPort(e.target.value)}>
            {commPortList.map((port, index) => (
              <option key={index} value={port}>
                {port}
              </option>
            ))}
          </Form.Control>
        </Col>
        <Col md="2">
          <Form.Label>장비 ID</Form.Label>
          <Form.Control type="text" value={inputAddress} onChange={(e) => setInputAddress(e.target.value)} />
        </Col>
        <Col md="2">
          <Form.Label>이름</Form.Label>
          <Form.Control type="text" value={inputName} onChange={(e) => setInputName(e.target.value)} />
        </Col>
        <Col md="2">
          <Form.Label>프로토콜</Form.Label>
          <Form.Control as="select" value={inputProtocol} onChange={(e) => setInputProtocol(e.target.value)}>
            {sensor_protocolList.map((protocol, index) => (
              <option key={index} value={protocol}>
                {protocol}
              </option>
            ))}
          </Form.Control>
        </Col>
        {inputcommPort === 'ETHERNET' && (
          <>
            <Col md="2">
              <Form.Label>IP 주소</Form.Label>
              <Form.Control type="text" value={inputEthernetIp} onChange={(e) => setInputEthernetIp(e.target.value)} />
            </Col>
            <Col md="2">
              <Form.Label>포트</Form.Label>
              <Form.Control type="text" value={inputEthernetPort} onChange={(e) => setInputEthernetPort(e.target.value)} />
            </Col>
          </>
        )}
        <Col md="2">
          <Button className="mt-4 w-100" onClick={evAddClick}>센서 추가</Button>
        </Col>
      </Row>

      {/* 테이블 - 온도 타입과 일사량 타입 체크박스로 선택 */}
      <Table striped bordered hover className="text-center mt-4" style={{ verticalAlign: 'middle' }}>
        <thead>
          <tr>
            <th>#</th>
            <th>통신 포트</th>
            <th>장비 ID</th>
            <th>이름</th>
            <th>프로토콜</th>
            <th>온도 타입</th>
            <th>일사량 타입</th>
            <th>송신 데이터</th> {/* 송신 데이터 열 추가 */}
            <th>수신 데이터</th> {/* 수신 데이터 열 추가 */}
            <th>수정</th>
            <th>삭제</th>
          </tr>
        </thead>
        <tbody>
          {Ev_list.seq && Ev_list.seq.length > 0 ? (
            Ev_list.seq.map((seq, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{Ev_list.ev_commPort?.[index] || '-'}</td>
                <td>{Ev_list.ev_address?.[index] || '-'}</td>
                <td>{Ev_list.ev_name?.[index] || '-'}</td>
                <td>{Ev_list.ev_protocol?.[index] || '-'}</td>
                <td>
                  <Form.Check
                    type="radio"
                    label="표면"
                    checked={temperatureTypes[index] === 0}
                    onChange={() => handleTemperatureChange(index, 0)}
                  />
                  <Form.Check
                    type="radio"
                    label="외기"
                    checked={temperatureTypes[index] === 1}
                    onChange={() => handleTemperatureChange(index, 1)}
                  />
                </td>
                <td>
                  <Form.Check
                    type="radio"
                    label="경사"
                    checked={sunTypes[index] === 0}
                    onChange={() => handleSunTypeChange(index, 0)}
                  />
                  <Form.Check
                    type="radio"
                    label="수평"
                    checked={sunTypes[index] === 1}
                    onChange={() => handleSunTypeChange(index, 1)}
                  />
                </td>
                <td>{evData.sendCount[index] || '-'}</td> {/* 송신 데이터 표시 */}
                <td>{evData.receiveCount[index] || '-'}</td> {/* 수신 데이터 표시 */}
                <td>
                  <Button variant="warning" size="sm" onClick={() => handleEditClick(index)}>수정</Button>
                </td>
                <td>
                  <Button variant="danger" size="sm" onClick={() => handleDeleteClick(index)}>삭제</Button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="9">등록된 환경센서가 없습니다.</td>
            </tr>
          )}
        </tbody>
      </Table>

      {/* 수정 모달 */}
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>EV 수정</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group>
              <Form.Label>통신 포트</Form.Label>
              <Form.Control as="select" value={inputcommPort} onChange={(e) => setcommPort(e.target.value)} className="text-center">
                {commPortList.map((port, index) => (
                  <option key={index} value={port}>
                    {port}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
            {inputcommPort === 'ETHERNET' && (
              <>
                <Form.Group>
                  <Form.Label>IP 주소</Form.Label>
                  <Form.Control
                    type="text"
                    value={inputEthernetIp}
                    onChange={(e) => setInputEthernetIp(e.target.value)}
                    placeholder="192.168.0.101"
                    className="text-center"
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label>포트</Form.Label>
                  <Form.Control
                    type="text"
                    value={inputEthernetPort}
                    onChange={(e) => setInputEthernetPort(e.target.value)}
                    placeholder="8080"
                    className="text-center"
                  />
                </Form.Group>
              </>
            )}
            <Form.Group>
              <Form.Label>장비 ID</Form.Label>
              <Form.Control
                type="text"
                value={inputAddress}
                onChange={(e) => setInputAddress(e.target.value)}
                className="text-center"
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>이름</Form.Label>
              <Form.Control
                type="text"
                value={inputName}
                onChange={(e) => setInputName(e.target.value)}
                className="text-center"
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>프로토콜</Form.Label>
              <Form.Control as="select" value={inputProtocol} onChange={(e) => setInputProtocol(e.target.value)} className="text-center">
                {sensor_protocolList.map((protocol, index) => (
                  <option key={index} value={protocol}>
                    {protocol}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>취소</Button>
          <Button variant="primary" onClick={handleSaveClick}>저장</Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
}

export default EnvironmentSetting;
